export default {
  all: {
    id: 'bo_sellers-orders-drawers-export_csv_file-export_all_orders',
    defaultMessage: 'Export all orders',
  },
  missingImeiNumbers: {
    id: 'bo_sellers-orders-drawers-export_csv_file-export_imeis',
    defaultMessage: 'Export missing IMEIs',
  },
  missingImeiNumbersDescription: {
    id: 'bo_sellers-orders-drawers-export_csv_file-export_imeis-description',
    defaultMessage: 'For smartphone orders only',
  },
  deliverySlips: {
    id: 'bo_sellers-orders-drawers-export_csv_file-export_packing_slips',
    defaultMessage: 'Export my packing slips',
  },
  backshipLabels: {
    id: 'bo_sellers-orders-drawers-export_csv_file-export_backship_labels',
    defaultMessage: 'Export backship labels',
  },
  invoices: {
    id: 'bo_sellers-orders-drawers-export_csv_file-export_customer_receipts',
    defaultMessage: 'Export customer receipts',
  },
} as const
